export default {
  trackViewContent() {
    if (typeof global.fbq === 'function') {
      global.fbq('track', 'ViewContent')
    } else {
      console.error("Facebook pixel hasn't been initialized!")
    }
  },
}
